import { render, staticRenderFns } from "./dept-view.vue?vue&type=template&id=0851bb14&scoped=true"
import script from "./dept-view.vue?vue&type=script&lang=js"
export * from "./dept-view.vue?vue&type=script&lang=js"
import style0 from "./dept-view.vue?vue&type=style&index=0&id=0851bb14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851bb14",
  null
  
)

export default component.exports